<template>
<div>
    <div class="a_position_f bg_opacity" style="width:100%;height:100%;z-index:10;top:0px;left:0;">
    </div>
    <div class="a_position_f" style="width:100%;z-index:11;top:0px;left:0px;height:100%;overflow-y: hidden;">
        <div
        style="width:100%;height:100%;overflow-y: scroll;padding:16px 0px;"
        >
            <div class="flex a_flex_a a_flex_column">
                <div class="a_position_r" style="padding:6px 30px 6px 30px;text-align:right;top:-10px;right:0px;width:100%"
                        @click="showMark"
                    >
                        <van-icon color="#fff" name="cross" />
                </div>
                <div ref="vardDetailDrow" class="card a_position_r " v-if="!cardShow&&!eacrdImg">
                    <div class="a_position_r">
                        <img src="@/assets/electronicCard/cardBg.png" alt="" style="width:100%;height:100%;border-radius: 3px;">
                    </div>
                    <div style="width:100%;height:100%;top:0;" class="a_position_a flex a_flex_a a_flex_column ">
                        <div class="position">{{posterData.position}} </div>
                        <div class="name">{{posterData.name}}</div>
                        <div class="a_position_r image">
                            <div style="width:100%;height:100%" class="a_position_a flex a_flex_a a_flex_j">
                                <img src="@/assets/electronicCard/ellipse415.png" alt="" style="width:100%;height:100%;" class="a_position_a">
                                <img :src="posterData.avatar" alt="" style="width:102px;height:102px;border-radius:50%">
                            </div>
                        </div>
                        <div class="serialNumber" v-if="posterData.userCode">
                            <div style="font-size: 12px;line-height: 12px;color: #2F70E2;">
                                编号{{posterData.userCode}}
                            </div>
                        </div>
                        <div class="location" v-if="posterData.storeAddress">{{posterData.storeAddress}}</div>

                    </div>
                    <div class="a_position_a card_bottom flex a_flex_a a_flex_j_sb" style="border-radius:0 0 8px 8px;">
                        <div>
                            <div class="lable">长按识别</div>
                            <div class="lable">查看更多服务惊喜</div>
                        </div>
                        <img :src="posterData.liveQrCode||posterData.qrCode" alt="" style="width:52px;height:52px">
                    </div>
                </div>
                <div class="a_position_r" v-if="(cardShow&&eacrdImg)||eacrdImg">
                    <img :src="eacrdImg" alt="" style="border-radius: 3px;width: 280px;height:498px;" >
                    <div class="tips">长按名片图片保存到手机/分享</div>
                </div>
                <div class="bud flex a_flex_a a_flex_j" v-if="!cardShow&&!eacrdImg" @click="saveCard">
                    保存到相册
                </div>

            </div>
        </div>

    </div>


</div>
</template>
<script>

// import html2canvas from 'html2canvas'
// 引入
import html2canvas from "@/lib/html2canvas"
export default {
  props:{
      posterData:{
        type: Object,
        default: function() {
            return {};
        },
      },
      eacrdImg:{
          type:String,
          default:function() {
            return "";
        },
      }
   },
  data(){
    return {
        cardShow:false,
        img:''
    }
  },
  watch: {
  },
  mounted(){
  },
  methods:{
    async saveCard(){
        let that=this;
        that.$Toast.loading({
          message: '生成中...',
          forbidClick: true,
          duration: 0,
        });
        if(!this.eacrdImg){
            document.body.scrollTop = 0;// 先滚动到最顶部
            document.documentElement.style.position = 'fixed';
        }
         that.posterData.avatar=await that.getBase64(that.posterData.avatar)
        if((that.posterData.liveQrCode||that.posterData.qrCode)&&that.posterData.avatar){
            that.$nextTick(()=>{
                //var shareContent = document.getElementById("shareContent"); // 需要绘制的部分的 (原生）dom 对象 ，注意容器的宽度不要使用百分比，使用固定宽度，避免缩放问题
                var scaleBy = 2; //获取像素密度的方法 (也可以采用自定义缩放比例)
                var width = 280*2; // 获取(原生）dom 宽度
                var height = 498*2; // 获取(原生）dom 高
                //var offsetTop = shareContent.offsetTop; //元素距离顶部的偏移量
                console.log('开始找canvas')
                var canvas = document.createElement("canvas"); //创建canvas 对象
                var context = canvas.getContext("2d");
                canvas.width = width*scaleBy ; //这里 由于绘制的dom 为固定宽度，居中，所以没有偏移
                canvas.height = height*scaleBy; // 注意高度问题，由于顶部有个距离所以要加上顶部的距离，解决图像高度偏移问题
                context.scale(scaleBy, scaleBy);
                console.log('准备画canvas')
                setTimeout(function() {
                    const dom = that.$refs.vardDetailDrow;
                    html2canvas(dom,{backgroundColor:null,allowTaint:true,tainttest: true,canvas: canvas,logging: false,useCORS:true,width: width,height: height,scale: scaleBy,removeContainer:true}).then((canvas)=> {
                        setTimeout(function() {
                            console.log('接收canvas')
                            try{
                                let canvasBase64=canvas.toDataURL("image/png"); // 转base64
                                if(canvasBase64){
                                    console.log('打印canvas')
                                    if (canvasBase64.indexOf('data:image') != 0) {                       
                                        //判断是否有前缀/没有则拼接(图片类型png,jpg按自己返回参数情况修改)                                              
                                        canvasBase64= 'data:image/png;base64,' +  canvasBase64
                                    }
                                    that.$emit('imgOK',canvasBase64)
                                    that.cardShow=true
                                    that.$Toast.clear()
                                    canvas.width = 0;
                                    canvas.height = 0;
                                    document.documentElement.style.position = '';
                                }else{
                                    that.$Toast.clear()
                                    that.$Toast.fail('下载失败')
                                    document.documentElement.style.position = '';
                                }
                            }catch(res){
                                console.log('下载失败',res)
                                that.$Toast.clear()
                                that.$Toast.fail('下载失败')
                                document.documentElement.style.position = '';
                            }
                        },200)
                    }).catch(()=>{
                        that.$Toast.clear()
                        that.$Toast.fail('下载失败')
                        document.documentElement.style.position = '';
                    })
              },500)

            })
        }else{
            that.$Toast.clear()
            that.$Toast.fail('头像下载失败')
        }

    },
    async getBase64(imgUrl) {
          const res = await  this.$http.get(`aocampaignsales/openapi/fileprocess/url2stream?imgUrl=${encodeURIComponent(imgUrl)}`,{responseType:'blob'})
          if(res && res.data){
             return await this.blobToBase64(res.data)
          }
    },
    async blobToBase64(blob){
       if(blob){
        return new Promise((resolve)=>{
          let oFileReader = new FileReader();
          oFileReader.onloadend = function (e) {
            resolve(e.target.result)
          }
          oFileReader.readAsDataURL(blob);
        })
      }else{
        return null
      }
    },
    showMark(){
        this.$emit('showMark', false)
    }
  }
}
</script>
<style lang="less" scoped>
.bg_opacity{
   background: #000000;
    mix-blend-mode: multiply;
    opacity: 0.78; 
}
.card{
   border-radius: 8px;
   width: 280px;
   height:498px;
   .position{
       color: #FFFFFF;
       font-weight: 300;
       font-size: 16px;
       line-height: 24px;
       margin-top: 80px;
   }
   .image{
       width:110px;height:110px;
       margin-top:22px;
   }
   .name{
       color: #FFFFFF;
       font-weight: 500;
       font-size: 32px;
       margin-top:8px;
   }
   .serialNumber{
       background: linear-gradient(270deg, #FFE25F 0%, #FDEFB8 100%);
       border-radius: 54px;
       padding:0px 18px;
       margin-top:20px;
       height: 24px;
       display: flex;
       align-items: center;
   }
   .location{
        color: #FDEFB2;
        font-size: 13px;
        line-height: 12px;
        margin-top:8px;
   }
   .card_bottom{
       bottom:0;
       left:0;
       width: 100%;
       height:80px;
       background: #fff;
       padding:0 16px;
       .lable{
           font-size: 11px;
           line-height: 20px;
           letter-spacing: 0.12em;
       }
   }
}
.bud{
    background: linear-gradient(270deg, #306FE2 24.05%, #1F7DDE 73.62%);
    border-radius: 50px;
    width: 206px;
    height:44px;
    color: #FFFFFF;
    font-size: 16px;
    line-height: 24px;
    margin-top:48px;
}
.tips{
    flex-grow: 0;
    flex-shrink: 0;
    text-align: center;
    line-height:120px;
    font-size:1.1rem;
    color:#fff;
  }

</style>